import React, {useState, useEffect} from 'react';
import Card from 'olive-react-myoneui/lib/Card';
import axios from 'axios';
import ReminderBlock from './ReminderBlock';
import NoItemsInfoReminder from './NoItemsInfoReminder';
import SampleImage from '../../assets/images/sample.png';
// import SampleImage2 from '../../assets/images/sample2.jpg';
// import jwtEncode from 'jwt-encode';
import {convertTimetoAmPm,convertUTCtoLocalTime, getDateInFormat} from '../../helpers/dateTimeHelper';
import { reminderModuleName, nodeUrl, nodeUrlDev } from '../../constants/config';
import { useTranslation } from 'react-i18next';
import { setLangInCache } from '../../utils/helpers';
import moment from 'moment';

function ReminderListGroup({accessToken,uuid,spUid,secret,idp,accountId, timeZone, language='en'}) {
  const [EventToken,setEventToken]= useState(null);
  const [reminders,setReminder]= useState([]);
  const [isValidImageUrl, setIsValidImageUrl] = useState(false);

  const { t, i18n} = useTranslation(reminderModuleName);
  let host                      = window.location.protocol + '//' +window.location.host;
  let currentUrl                = window.location.href;

  const langSet = (lang) => {
    // console.log('lang in reminder', lang);
    i18n.changeLanguage(lang);
    setLangInCache(lang);
  };

  useEffect(() => {
    langSet(language);
  },[language]);
  
  const eventToken = () => {
    // const data = {
    //   'account_id'  : accountId,
    //   'product_id'  : 'mykademy',
    //   'iat'         : 1516239022
    // };
    // const jwt = jwtEncode(data, eventSecret);
    setEventToken(accessToken);
    // const headers = {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Bearer ${secret}`
    //   // 'Authorization': `Bearer bb289a32abaac489fc6209044659e5c29093bg33`
    // }
    // var data = {
    //   "grant_type": "bearer_token",
    //   "account_id": `${accountId}`,
    //   "product_id": "eportfolia"
    // }
    // axios.post('https://'+idp+'/api/v1/generate_token',data, {
    //   headers
    // })
    // .then((response) => {
    //   setEventToken(response.data.data.token)
    // });
    // axios.get('https://enquiry-devapi.mykademy.com/events/token').
    // then((response) => {
    //   // console.log('ressk', response.data.token);
    //   setEventToken(response.data.token)
    // });
  }

  const EventList = (EventToken) => {
    if(EventToken){
      const headers = {
        'Content-Type': 'application/json',
        // 'x-access-token' : 'NKNvNTNtNp7wNzNX7uNzNT7v7ZNjN'
        'Authorization': `Bearer ${EventToken}`
      }
      // var data = {
      //   'account_id':accountId,
      // }
      let limit = 30;

      const startDate = getDateInFormat(convertUTCtoLocalTime(moment().format('YYYY-MM-DD'), timeZone), 'yyyy-mm-dd');
      const endDate = getDateInFormat(convertUTCtoLocalTime(moment().add(30, 'days').format('YYYY-MM-DD'), timeZone), 'yyyy-mm-dd');

      axios.get(`${nodeUrl}events/reminder?limit=${limit}&page=1&account_id=${accountId}&us_uuid=${uuid}&start_date=${startDate}&end_date=${endDate}`, {
        headers
      })
      .then((response) => {
        if(response?.data?.result?.events?.length > 0){
          setReminder(response.data.result.events)
        }
      });
    }
  }


  useEffect(() => {
    eventToken()
  }, []);

  useEffect(() => {
    EventList(EventToken)
  }, [EventToken]);

  let Reminder = '';
  let reminderImage = SampleImage;
  Reminder = reminders.length ? reminders.map((reminder,i) => {  
    let reminderImage = reminder['reminder_image'];
    if (!isValidImageUrl(reminderImage)) {
      reminderImage = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/course/default-lecture.jpg';
    }


    const days    = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const month   = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    let startDate = convertUTCtoLocalTime(reminder.start_date, timeZone);
    let endDate   = convertUTCtoLocalTime(reminder.end_date, timeZone);
    let endHours  = endDate.getHours();
    endHours        = ("0" + endHours).slice(-2);
    let endMinutes  = endDate.getMinutes();
    endMinutes      = ("0" + endMinutes).slice(-2);

    let fullYear    = startDate.getFullYear();
    let eFullYear   = endDate.getFullYear();

    let index       = startDate.getDay();
    let endIndex      = endDate.getDay();
    let day         = days[index];
    let eDay        = days[endIndex];
    let date        = startDate.getDate();
    let eDate       = endDate.getDate();
    let hours       = startDate.getHours();
    hours           = ("0" + hours).slice(-2);
    let minutes     = startDate.getMinutes();
    minutes         = ("0" + minutes).slice(-2);
    let monthIndex  = startDate.getMonth();
    let endMonthIndex = endDate.getMonth();
    let monthName   = month[monthIndex];
    let eMonthName  = month[endMonthIndex];

    let convertedStartTime  = convertTimetoAmPm(hours+':'+minutes);
    let convertedEndTime    = convertTimetoAmPm(endHours+':'+endMinutes);
    let event_date = `${day}, ${date} ${monthName} | ${convertedStartTime} - ${convertedEndTime}`;
    if(date != eDate || monthIndex != endMonthIndex || fullYear != eFullYear){
      event_date = `${day}, ${date} ${monthName} ${convertedStartTime} - ${eDay}, ${eDate} ${eMonthName} ${convertedEndTime}`;
    }

    let aEndDate      = reminder.reminder_date;
    aEndDate          = convertUTCtoLocalTime(aEndDate, timeZone);
    let aMonthIndex   = aEndDate.getMonth();
    let aMonthName    = month[aMonthIndex];
    let aDayIndex     = aEndDate.getDay();
    let aDay          = days[aDayIndex];
    let aDate         = aEndDate.getDate();
    let aYear         = aEndDate.getFullYear();
    let aEndHours     = aEndDate.getHours();
    aEndHours         = ("0" + aEndHours).slice(-2);
    
    let aEndMinutes   = aEndDate.getMinutes();
    aEndMinutes       = ("0"+aEndMinutes).slice(-2);

    let convertedAssigmentTime  = convertTimetoAmPm(aEndHours+':'+aEndMinutes);
    let assignmentEndDate       = `${aDay}, ${aDate} ${aMonthName} ${convertedAssigmentTime}`;
    let launch_url              = reminder.launch_url;
    if(reminder.reminder_type == 'assignment'){
      launch_url = `${host}/materials/course/${reminder.reminder_course_id}/${reminder.reminder_id}/?callback=${currentUrl}`;
    }

    function isValidImageUrl(url) { 
      if (!url) {
        return false;  
      } 
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.svg'];
      const lowerCaseUrl = url.toLowerCase();
      return (
        (lowerCaseUrl.startsWith('http://') || lowerCaseUrl.startsWith('https://')) &&
        imageExtensions.some(ext => lowerCaseUrl.endsWith(ext))
      );
    }
    return(
        <ReminderBlock
            key={reminder.reminder_id} 
            className="mb-3"
            reminderTitle={reminder.reminder_name}
            reminderLogo={reminderImage}
            reminderButton={reminder.reminder_type == 'live'? t('Join') : ((reminder.reminder_type === 'assignment') ? t('Submit') : (reminder.reminder_type === 'link' ? t('Open') : ''))} 
            joinLink={launch_url} 
            reminderTime={reminder.reminder_type == 'live' ? event_date : assignmentEndDate}
            reminderType={reminder.reminder_type}
          />
    )
  }) :"";


  return (
    reminders.length ? (
      <Card className="border-0">
      <Card.Body className="p-0">
        <Card.Header>
          <strong>{t('Reminders')}</strong>
        </Card.Header>
        <Card.Body>
        <div className="liveclasses-reminders-wrapper test123">
          {Reminder}
          </div>
        </Card.Body>
      </Card.Body>
    </Card>
    ) : (
      <NoItemsInfoReminder />
    )
  );
}

export default React.memo(ReminderListGroup);
